
import Banner from './banner/Banner'
import Header from '../../ui/includes/Header'
import About from './About'
import Services from './services/Services'
import Stats from './stats/Stats'
import CeoMessage from './ceo/CeoMessage'
import WhyChooseUs from './whChoose/WhyChoose'
// import Projects from './projects/Projects'
// import Faqs from './faqs/Faqs'
import Contact from './contact/Contact'
import Footer from '../footer/Footer'
import Projects from './projects/Projects'



const Index = () => {
    return (
        <>
            <Header />
            <Banner />
            <About />
            <Services />
            
            
            <WhyChooseUs />
            <Projects />
            <Contact />
            <Footer />
            {/* 
            <Projects />
            <Faqs />
            
             */}
        </>
    )
}

export default Index
